export default {
    form: { backgroundColor: '#F0E0BE', borderColor: '#c4aa74' },
    list: { backgroundColor: '#F0E0BE', borderColor: '#c4aa74' }
  }